import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { lastClientIdSelector } from '../../administration/applicationSettings/store/selectors';
import { withPermissions, permissions } from '../../shared/authorization';
import { useUserExpiration, UserExpiration } from '../../shared/queries/users';
import { useRoleCheckPrivilege } from '../../shared/queries/roles';
import { useUpdateExpirationUsers } from '../../shared/mutations/users';
import UserExpirationData from './userExpirationData.component';
import { assignablePermissionTypes } from '@common/constants/assignablePermissions';

const UserExpirationPage = () => {
  const lastClientId = useSelector(lastClientIdSelector);

  const {
    data: userCanEditExpirationDate,
    isLoading: isLoadingPrivileges,
  } = useRoleCheckPrivilege(assignablePermissionTypes.UserExpiration);

  const {
    isLoading: isLoadingExpirationData,
    data: expirationData,
    isFetching: isFetchingExpirationData,
    refetch: refetchUsersData,
  } = useUserExpiration(lastClientId);

  const isLoadingUsers = isLoadingExpirationData || isFetchingExpirationData;

  const handleSuccessUpdate = () => {
    refetchUsersData();
  };

  const {
    mutate: updateExpirationUsers,
    isLoading: isLoadingUpdateExpiration,
  } = useUpdateExpirationUsers(handleSuccessUpdate);

  const handleSubmitUsers = useCallback((usersToUpdate: UserExpiration[]) => {
    updateExpirationUsers(usersToUpdate);
  }, [updateExpirationUsers]);

  return (
    <div className="ag-grid-full-page-with-secondary-menu">
      <div className="page">
        <div className="container-fluid page-content-container">
          <div className="row no-gutters">
            <div className="col">
              <div className="d-flex flex-row justify-content-between expiration-title">
                <h5>User Expiration</h5>
              </div>
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col">
              <UserExpirationData
                users={isLoadingUsers ? [] : expirationData}
                canEditExpirationDate={userCanEditExpirationDate}
                isLoading={isLoadingUsers || isLoadingUpdateExpiration || isLoadingPrivileges}
                submitUsers={handleSubmitUsers}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withPermissions(permissions.USER_ADMINISTRATION)(UserExpirationPage);
